import React from 'react';
import PropTypes from 'prop-types';

const Briefcase = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="briefcase-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.632 4.5V9h-4.421V2.25c0-1.24.991-2.25 2.21-2.25H58.58c1.22 0 2.21 1.01 2.21 2.25V9h-4.42V4.5H27.632zM9.91 45H0V15.75c0-1.24.991-2.25 2.21-2.25H81.79c1.22 0 2.211 1.01 2.211 2.25V45H55.263v-4.5H79.58V18H4.42v22.5h24.316V45H9.91zM79.58 67.5v-18H84v20.25c0 1.24-.991 2.25-2.21 2.25H2.21C.992 72 0 70.99 0 69.75V49.5h4.421v18h75.158zm-42-20.25h8.842v-9H37.58v9zm-2.21 4.5h13.263c1.219 0 2.21-1.01 2.21-2.25V36c0-1.24-.991-2.25-2.21-2.25H35.369c-1.22 0-2.21 1.01-2.21 2.25v13.5c0 1.24.99 2.25 2.21 2.25z"
      fill="#fff"
    />
  </svg>
);

Briefcase.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Briefcase.defaultProps = {
  width: 84,
  height: 72,
};

export default Briefcase;
